import { FieldModel } from '../../../services/actions/models/field.model';
import {
  BooleanSelectFieldComponent,
  DatepickerFieldNewComponent,
  DisplayFilterInterface,
  SelectComponent,
} from '@platform500services/p500-ui-kit';
import { CountryRegion } from '../../fields/default/country-region/types';
import { TimeZoneConfig } from '../../../time-zone/time-zone.config';
import { CountryRegionComponent } from '../../fields/default/country-region/country-region.component';

export function getDisplayFilters(field: FieldModel, timeZoneConfig: TimeZoneConfig, dataValue?: any): DisplayFilterInterface {
  const component = field.component;
  const data = dataValue || field.settings['data'];
  const value = field.formControl.value;
  let displayValue: string;

  switch (component) {
    case SelectComponent: {
      const bindValue = field.settings?.['bindValue'];
      const bindLabel = field.settings?.['bindLabel'];
      if (bindValue && bindLabel && Array.isArray(data)) {
        displayValue = data
          .filter((item) => valueToArray(value).includes(item[bindValue]))
          .map((item) => `"${item[bindLabel]}"`)
          .join(', ');
      } else {
        displayValue = Array.isArray(value)
          ? value
              .map((item) => {
                let name: string;
                if (data[item] && (data[item] as any).name) {
                  name = (data[item] as any).name;
                } else {
                  name = data[item] ? data[item] : item;
                }

                return `"${name}"`;
              })
              .join(', ')
          : `"${data[value] && data[value].name ? data[value].name : data[value]}"`;
      }
      break;
    }
    case DatepickerFieldNewComponent: {
      const date = Array.isArray(value) ? value[0] : value;
      displayValue = timeZoneConfig.getDate(date, { pretty: true });
      break;
    }
    case BooleanSelectFieldComponent:
      displayValue =
        Array.isArray(value) && value.length
          ? value[0] === 1 || value[0] === '1' || value[0] === true || value[0] === 'true'
            ? `"${$localize`:@@common.yes:Yes`}"`
            : `"${$localize`:@@common.no:No`}"`
          : value === 1 || value === '1' || value === true || value === 'true'
          ? `"${$localize`:@@common.yes:Yes`}"`
          : `"${$localize`:@@common.no:No`}"`;
      break;
    case CountryRegionComponent: {
      const { country_code, region_code } = Array.isArray(value) ? value[0] : value;
      const countryLabel = country_code ? `${$localize`:@@common.country:Country`}: ${country_code.join(', ')}` : '';
      const regionLabel = region_code ? `${$localize`:@@common.region:Region`}: ${region_code.join(', ')}` : '';
      displayValue = `${countryLabel}${(countryLabel && regionLabel && ';') || ''}${regionLabel}`;
      break;
    }
    default:
      displayValue = Array.isArray(value) ? value.map((item) => `"${item}"`).join(', ') : `"${value}"`;
      break;
  }
  return {
    key: field.key,
    name: filterTranslationLabels[field.label] || field.label,
    value: displayValue,
  };
}

export const valueToArray = <T = any>(value: T): T[] => (Array.isArray(value) ? value : [value]);

export function controlIsEmpty(controlValue: unknown[] | any): boolean {
  if (controlValue === null) {
    return true;
  }
  if (typeof controlValue[0] === 'object') {
    return controlObjectValueIsEmpty(controlValue[0]);
  }
  return false;
}

function controlObjectValueIsEmpty(controlValue: object): boolean {
  if (
    Object.prototype.hasOwnProperty.call(controlValue, 'country_code') &&
    Object.prototype.hasOwnProperty.call(controlValue, 'region_code')
  ) {
    const checkedValue = controlValue as CountryRegion;
    return !(checkedValue.country_code?.length || checkedValue.region_code?.length);
  }
  return false;
}

const filterTranslationLabels = {
  Type: $localize`:@@common.type:Type`,
  'Goal Type ID': $localize`:@@common.goal_type_id:Goal Type ID`,
  'Payout Model ID': $localize`:@@common.payout_model_id:Payout Model ID`,
  'Hide Zero Payout': $localize`:@@common.hide_zero_payout:Hide Zero Payout`,
  Approved: $localize`:@@common.approved:Approved`,
};
